<template>
    <div class="addWx">
        <el-dialog title="解绑微信" width="30%" :visible.sync="visible">
            <div>
                <p>是否确认解绑？</p>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="visible = false">关 闭</el-button>
                <el-button type="primary" @click="confirm">确 认</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { unbind } from '@/api/personal';
export default {
    name: 'addWx',
    components: {
        
    },
    data() {
        return {
            visible: false,
            wx_id: ''
        }
    },
    methods: {
        show(id) {
            this.wx_id = id
            this.visible = true
        },
        async confirm() {
            const {code} = await unbind({account_wechat_id: this.wx_id})
            if(code === 0) {
                this.$message.success('解绑成功')
                this.$emit('Refresh')
                this.visible = false
            }
        }
    }
}
</script>
<style lang="less" scoped>

</style>